// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsEc2SecurityGroupsIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-ec2-security-groups_svga)" d="M40 0H0v40h40z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M27 22.57c-.02 1.23-.39 7.2-6 7.54V10.44l6 2.32zm-13-.73v-9.08l6-2.32V30.1c-5.75-.4-6-7.43-6-8.26m6.32-12.6-7 2.7a.5.5 0 0 0-.32.47v9.44c0 .95.29 9.3 7.5 9.3 7.05 0 7.48-7.14 7.5-8.58V12.41a.5.5 0 0 0-.32-.46l-7-2.7a.5.5 0 0 0-.36 0M30 22.58c0 .03-.02 2.7-1.21 5.33q-2.37 5.23-8.3 5.24c-3.91 0-6.7-1.87-8.27-5.56A17 17 0 0 1 11 21.86V10.7l9.5-3.66L30 10.7zm.68-12.68-10-3.86a.5.5 0 0 0-.36 0l-10 3.86a.5.5 0 0 0-.32.46v11.5c0 .13.12 12.3 10.5 12.3S31 22.68 31 22.56V10.35a.5.5 0 0 0-.32-.46"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="aws-ec2-security-groups_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsEc2SecurityGroups",
);
export default AwsEc2SecurityGroupsIcon;
